import styled from 'styled-components';
import { themeGet } from '../../theme/utils';

export const Badge = styled.span`
  text-align: center;
  padding: calc(${themeGet.space(1)} / 2) ${themeGet.space(1)};
  font-size: calc(${themeGet.fontSize(0)} * 3 / 4);
  font-weight: ${themeGet.fontWeight('bold')};
  color: ${themeGet.colors('primaryDark')};
  background-color: ${themeGet.colors('white')};
  border: 1px solid ${themeGet.colors('primaryDark')};
  border-radius: 6px;
  line-height: 1;
`;
